<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import Grid from '../components/Shared/Grid'
import UserDetailsModal from '../components/User/UserDetailsModal'
import ChipTemplate from '../components/Shared/ChipTemplate'
import { formatAddress } from '../utils'

export default {
  name: 'Users',
  components: {
    Grid,
    UserDetailsModal,
    ChipTemplate
  },
  created(){
    let vm = this
    let isAdmin = vm.$p(['ADMIN'])
    let isManager = vm.$p(['MANAGER'])
    let isAffiliate = vm.$p(['AFFILIATE'])
    let isRecruiter = vm.$p(['RECRUITER'])
    if(isAdmin){
      return vm.changeSearchType('all')
    }
    else{
      let searchType
      if(isRecruiter) searchType = 'affiliates'
      if(isAffiliate) searchType = 'instructors'
      if(isManager)   searchType = 'affiliates'
      vm.changeSearchType(searchType)
    }
  },
  updated(){
    let vm = this
    if(!vm.initialized){
      $(function(){
        if($(".pill-slider").find("li").length > 0){
          //$(".pill-slider").find("li").eq(0).click()
          vm.initialized = true
        }
      })
    }
  },
  data () {
    let vm = this
    return {      
      openFAB: false,
      initialized: false,
      module: vm.$route.meta.module,
      selection: 'multiple',
      selected: [],
      visibleColumns: ['USER_ID'],
      usersSearchOpen: false,
      columnOptions: [
        { field: 'AFFILIATE', sortColumn:'AFFILIATE.AFFILIATE_NAME', name: 'AFFILIATE_NAME', label: 'Affiliate Name', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.AFFILIATE_NAME : null }
        },
        { field: 'AFFILIATE', name: 'AFFILIATE_CODE', sortColumn:'AFFILIATE.AFFILIATE_CODE', label: 'Affiliate Code', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.AFFILIATE_CODE : null }
        },
        { field: 'AFFILIATE', name: 'AFFILIATE_PROCESSING', sortColumn:'AFFILIATE.STUDENT_PROCESSING_FEE', label: 'Processing Fee', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.STUDENT_PROCESSING_FEE : null }
        },
        
        { field: 'INSTRUCTOR', name: 'INSTRUCTOR_CODE', sortColumn:'INSTRUCTOR.INSTRUCTOR_CODE', label: 'Instructor Code', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.INSTRUCTOR_CODE : null }
        },
        { field: 'USER_FIRST_NAME', name: 'USER_FIRST_NAME', label: 'First Name', sortable: true, filterable: true, filter: '', type: 'string' },
        { field: 'USER_LAST_NAME', name: 'USER_LAST_NAME', label: 'Last Name', sortable: true, filterable: true, filter: '', type: 'string' },
        { field: 'RECRUITER', name: 'RECRUITER_CODE', sortColumn:'RECRUITER.RECRUITER_CODE', label: 'Recruiter Code', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.RECRUITER_CODE : null }
        },//{ field: 'STATE_NAME', name: 'STATE_NAME', label: 'State', sortable: true, filterable: true, filter: null, type: 'state' },
        { field: 'USER_DOB', name: 'USER_DOB', label: 'Date of Birth', sortable: true, filterable: false, filter: '', type: 'string' },
        { field: 'USER_PHONE', name: 'USER_PHONE', label: 'Phone', sortable: true, filterable: true, filter: '', type: 'string' },
        { field: 'USER_EMAIL', name: 'USER_EMAIL', label: 'Email', sortable: true, filterable: true, filter: '', type: 'string' },
        { field: 'ACTIVE_IND', name: 'ACTIVE_IND', label: 'User Status', sortable: true, filterable: true, filter: '', type: 'boolean' },
        { field: 'MANAGER', name: 'MANAGER_ACTIVE_IND', sortColumn:'MANAGER.ACTIVE_IND', label: 'Manager Status', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.ACTIVE_IND : null }
        },
        { field: 'AFFILIATE', name: 'AFFILIATE_ACTIVE_IND', sortColumn:'AFFILIATE.ACTIVE_IND', label: 'Affiliate Status', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.ACTIVE_IND : null }
        },
        { field: 'RECRUITER', name: 'RECRUITER_ACTIVE_IND', sortColumn:'RECRUITER.ACTIVE_IND', label: 'Recruiter Status', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.ACTIVE_IND : null }
        },
        { field: 'AFFILIATE', name: 'AFFILIATE_RECRUITER', sortColumn:'AFFILIATE.RECRUITER.USER.USER_FIRST_NAME', label: 'Affiliate Recruiter', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => {
            let name = null
            if (r && r.RECRUITER && r.RECRUITER.USER) {
              const { USER_FIRST_NAME, USER_LAST_NAME } = r.RECRUITER.USER
              name = `${USER_FIRST_NAME} ${USER_LAST_NAME}`
            }

            return name
          }
        },
        { field: 'ADDRESSES', name: 'MAILING_ADDRESS', label: 'Mailing Address', sortable: false, filterable: false, type: 'string',
          format: addresses => {
            const mailing = addresses.find(a => a.LK_ADDRESS_TYPE_ID == 4)
            if (mailing) {
              return formatAddress(mailing)
            }

            return null
          }
        },
        { field: 'ADDRESSES', name: 'BILLING_ADDRESS', label: 'Billing Address', sortable: false, filterable: false, type: 'string',
          format: addresses => {
            const billing = addresses.find(a => a.LK_ADDRESS_TYPE_ID == 3)
            if (billing) {
              return formatAddress(billing)
            }

            return null
          }
        },
        { field: 'AFFILIATE', name: 'PRINT_PERMISSIONS', label: 'Print Permissions', sortColumn: 'AFFILIATE.PRINT_PERMISSION', sortable: true, filterable: false, type: 'string',
          format: affiliate => affiliate.PRINT_PERMISSION
        },
        { field: 'AFFILIATE', name: 'SCHOOL_ENTERED', label: 'School Entered Data', sortColumn: 'AFFILIATE.SCHOOL_ENTERED', sortable: true, filterable: false, type: 'string',
          format: affiliate => affiliate.SCHOOL_ENTERED
        },
        { field: 'INSTRUCTOR', name: 'INSTRUCTOR_ACTIVE_IND', sortColumn:'INSTRUCTOR.ACTIVE_IND', label: 'Instructor Status', sortable: true, filterable: true, filter: '', type: 'string',
          format: r => { return r ? r.ACTIVE_IND : null }
        },
        { field: 'INSTRUCTOR', name: 'INSTRUCTOR_ASSOCIATED_AFFILIATES', sortColumn: 'INSTRUCTOR.AFFILIATES.AFFILIATE.AFFILIATE_CODE', label: 'Associated Affiliates', sortable: false, filterable: true, filter: 'string', type: 'string',
          format: r => {
            if (r && r.AFFILIATES) {
              return r.AFFILIATES.map(aff => aff.AFFILIATE.AFFILIATE_CODE)
            }

            return null
          }
        },
      ]
    }
  },
  computed: {
    ...mapGetters('users', [
      'userList'
    ]),
    ...mapState('users', {
      loadingData: s => s.loadingData,
      searchType: s => s.searchType,
      searchFields: s => {
        return s.searchFields[s.searchType]
      },
      userSearchColumns: s => s.userSearchColumns,
      activeSearchType:  s => s.activeSearchType
    }),
    ...mapGetters([
      'activeIndicators'
    ]),
    getVisibleColumns(){
      let vm = this
      vm.visibleColumns = vm.userSearchColumns[vm.activeSearchType]
      return vm.visibleColumns
    },
    userTypeOptions(){
      let vm = this
      let options = [
        { label: "All", value: "all", $p: [['ADMIN']] },
        { label: "Administrators", value: "administrators", $p: [['ADMIN']] },
        { label: "Managers", value: "managers", $p: [['ADMIN']] },
        { label: "Affiliates", value: "affiliates", $p: [['ADMIN','MANAGER','RECRUITER'],'or'] },
        { label: "Instructors", value: "instructors", $p: [['ADMIN','MANAGER','AFFILIATE'],'or'] },
        { label: "Recruiters", value: "recruiters", $p: [['ADMIN','MANAGER'],'or'] },
      ]
      return options.filter(o => vm.$p(o.$p[0], o.$p[1]))
    }
  },
  methods: {
    ...mapActions('users', [
      'fetch',
      'select',
      // 'addNew',
      'exportExcel',
    ]),
    ...mapMutations('users',[
      'changeSearchType',
      'resetSearchFields',
      'openUserWizardModal'
    ]),
    fetchAndClear(){
      let vm = this
      vm.resetSearchFields()
      vm.$root.$emit('refreshGrid:userListGrid')
    },
    fetchMethod() {
      let vm = this 
      vm.usersSearchOpen = true
      vm.$root.$emit('refreshGrid:userListGrid')
    },
    changeSearchTypeMethod(type){      
      let vm = this
      vm.resetSearchFields()
      vm.changeSearchType(type)
      vm.$root.$emit('refreshGrid:userListGrid')
      vm.usersSearchOpen = true
    },
    selectUser(selectedUser){
      let vm = this
      vm.select({selectedUser, vm })
        .then(() => {
          vm.$q.loading.hide()
        })
    },
    toggleFAB() {
      this.openFAB = !this.openFAB
    }
  }
}
</script>

<template>
  <q-page class="stretch-grid has-search">
   
    <q-collapsible id="userSearchTop" class="search-box" icon-toggle collapse-icon="fa fa-angle-down" v-model="usersSearchOpen">
      <template slot="header" class="search-box">
        <q-icon name="fa fa-search" color="primary" size="20px" style="padding:0 0 3px 10px" />
        <div class="pill-slider gt-sm">
          <ul>
            <li v-if="$p(['ADMIN'])" :class="{active:searchType == 'all'}" @click.prevent.stop="changeSearchTypeMethod('all')">All</li>
            <li v-if="$p(['ADMIN'])" :class="{active:searchType == 'administrators'}" @click.prevent.stop="changeSearchTypeMethod('administrators')">Administrators</li>
            <li v-if="$p(['ADMIN'])" :class="{active:searchType == 'managers'}" @click.prevent.stop="changeSearchTypeMethod('managers')">Managers</li>
            <li v-if="$p(['ADMIN','MANAGER','RECRUITER'],'or')" :class="{active:searchType == 'affiliates'}" @click.prevent.stop="changeSearchTypeMethod('affiliates')">Affiliates</li>
            <li v-if="$p(['ADMIN','MANAGER','AFFILIATE'],'or')" :class="{active:searchType == 'instructors'}" @click.prevent.stop="changeSearchTypeMethod('instructors')">Instructors</li>
            <li v-if="$p(['ADMIN','MANAGER'],'or')" :class="{active:searchType == 'recruiters'}" @click.prevent.stop="changeSearchTypeMethod('recruiters')">Recruiters</li>
          </ul>
        </div>
        <div class="lt-md sl-row" style="width:100%">
          <div class="sl-col-12">
            <q-select
              float-label="User Type"
              :value="searchType"
              :options="userTypeOptions"
              @change="v => changeSearchType(v)"
            />
          </div>
        </div>        
      </template>
      <form v-on:submit.prevent="">
        
        <!-- All -->
        <div v-if="searchType === 'all'" class="sl-row" style="padding:0 30px 5px">
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="First Name" v-model="searchFields.USER_FIRST_NAME" /></div>
            <div class="sl-col-4"><q-input float-label="Last Name" v-model="searchFields.USER_LAST_NAME"/></div>
            <div class="sl-col-4">
              <q-select
                float-label="Status"
                v-model="searchFields.ACTIVE_IND"
                :options="activeIndicators"
              />
            </div>
          </div>
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="Phone" v-model="searchFields.USER_PHONE"/></div>      
            <div class="sl-col-4"><q-input float-label="Email" v-model="searchFields.USER_EMAIL"/></div>    
          </div>          
        </div>

        <!-- instructors -->      
        <div v-if="searchType === 'instructors'" class="sl-row" style="padding:0 30px 5px">
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="Instructor Code" v-model="searchFields['INSTRUCTOR.INSTRUCTOR_CODE']"/></div>
            <div class="sl-col-4"><q-input float-label="First Name" v-model="searchFields.USER_FIRST_NAME"/></div>
            <div class="sl-col-4"><q-input float-label="Last Name" v-model="searchFields.USER_LAST_NAME"/></div>   
                
          </div>
          <div class="sl-row no-margin">
            <div class="sl-col-4">
                <q-select
                  float-label="Status"
                  v-model="searchFields['INSTRUCTOR.ACTIVE_IND']"
                  :options="activeIndicators"
                />
              </div>
            <div class="sl-col-4"><q-input float-label="Affiliate Code" v-model="searchFields['INSTRUCTOR.AFFILIATES.AFFILIATE.AFFILIATE_CODE']"/></div>
            <div class="sl-col-4"><q-input float-label="Phone" v-model="searchFields.USER_PHONE"/></div>  
          </div>
        </div>
        
        <!-- affiliates -->
        <div v-if="searchType === 'affiliates'" class="sl-row" style="padding:0 30px 5px">
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="Affiliate Code" v-model="searchFields['AFFILIATE.AFFILIATE_CODE']"/></div>
            <div class="sl-col-4"><q-input float-label="Affiliate Name" v-model="searchFields['AFFILIATE.AFFILIATE_NAME']"/></div>
            <div class="sl-col-4">
              <q-select
                float-label="Status"
                v-model="searchFields['AFFILIATE.ACTIVE_IND']"
                :options="activeIndicators"
              />
            </div> 
          </div>
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="Recruiter Code" v-model="searchFields['RECRUITER.RECRUITER_CODE']"/></div>
            <div class="sl-col-4"><q-input float-label="Processing Fee" v-model="searchFields['AFFILIATE.STUDENT_PROCESSING_FEE']"/></div>
            <div class="sl-col-4"><q-input float-label="Phone" v-model="searchFields.USER_PHONE" /></div> 
          </div>
        </div>
        
        <!-- administrators -->
        <div v-if="searchType === 'administrators'" class="sl-row" style="padding:0 30px 5px">
          <div class="sl-row no-margin">
              <div class="sl-col-4"><q-input float-label="First Name" v-model="searchFields.USER_FIRST_NAME"/></div>
              <div class="sl-col-4"><q-input float-label="Middle Name" v-model="searchFields.USER_MIDDLE_NAME"/></div>
              <div class="sl-col-4"><q-input float-label="Last Name" v-model="searchFields.USER_LAST_NAME"/></div> 
          </div>
          <div class="sl-row no-margin">
              <div class="sl-col-4"><q-input float-label="Phone" v-model="searchFields.USER_PHONE"/></div>       
              <div class="sl-col-4"><q-input float-label="Email" v-model="searchFields.USER_EMAIL"/></div>             
          </div>
        </div>
        
        <!-- recruiters -->
        <div v-if="searchType === 'recruiters'" class="sl-row" style="padding:0 30px 5px">
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="Affiliate Code" v-model="searchFields['RECRUITER.AFFILIATES.AFFILIATE_CODE']"/></div>
            <div class="sl-col-4"><q-input float-label="Affiliate Name" v-model="searchFields['RECRUITER.AFFILIATES.AFFILIATE_NAME']"/></div>
            <div class="sl-col-4">
              <q-select
                float-label="Status"
                v-model="searchFields['RECRUITER.ACTIVE_IND']"
                :options="activeIndicators"
              />
            </div> 
          </div>
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="Recruiter Code" v-model="searchFields['RECRUITER.RECRUITER_CODE']"/></div>  
            <div class="sl-col-4"><q-input float-label="Recruiter Fee" v-model="searchFields['RECRUITER.RECRUITER_FEE']"/></div>   
            <div class="sl-col-4"><q-input v-model="searchFields['USER_PHONE']" float-label="Phone"/></div>     
          </div>
        </div>

        <!-- managers -->
        <div v-if="searchType === 'managers'" class="sl-row" style="padding:0 30px 5px">
          <div class="sl-row no-margin">
            <div class="sl-col-4"><q-input float-label="First Name" v-model="searchFields.USER_FIRST_NAME" /></div>
            <div class="sl-col-4"><q-input float-label="Last Name" v-model="searchFields.USER_LAST_NAME" /></div>         
          </div>
        </div>  

        <q-toolbar color="white" style="padding-right:60px">
          <q-toolbar-title></q-toolbar-title>
          <q-btn color="secondary" label="Clear" outline size="sm" type="reset" style="margin-right:5px" @click="fetchAndClear"/> 
          <q-btn color="primary" label="Search" size="sm" type="submit" @click="fetchMethod()" />
        </q-toolbar>
      </form>
    </q-collapsible>

    <Grid
      id="userListGrid"
      :module="module"
      :data="userList"
      :columns="columnOptions"
      :onLaunch="selectUser"
      :loading="loadingData"
      :onRequest="fetch"
      :onExport="fetch"
      :visibleColumns="getVisibleColumns">
      <template slot="col-item-active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label"
              :class="{
                  'green' : props.value === true,
                  'red' : props.value === false
              }">
                {{props.value ? 'Active' : 'Inactive'}}
              </div>
      </template>
      <template slot="col-item-affiliate_active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label"
              :class="{
                  'green' : props.value == 1,
                  'red' : props.value == 0
              }">
                {{props.value ? 'Active' : 'Inactive'}}
              </div>
      </template>
      <template slot="col-item-manager_active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label"
              :class="{
                  'green' : props.value == true,
                  'red' : props.value == false
              }">
                {{props.value ? 'Active' : 'Inactive'}}
              </div>
      </template>
      <template slot="col-item-instructor_active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label"
              :class="{
                  'green' : props.value == true,
                  'red' : props.value == false
              }">
                {{props.value ? 'Active' : 'Inactive'}}
              </div>
      </template>
      <template slot="col-item-recruiter_active_ind" slot-scope="props">
        <div style="display:inline-block;margin-left: 10px;border-radius:30px" 
              class="label"
              :class="{
                  'green' : props.value == true,
                  'red' : props.value == false
              }">
                {{props.value ? 'Active' : 'Inactive'}}
              </div>
      </template>
      <template slot="col-item-instructor_associated_affiliates" slot-scope="props">
        <div style="display:inline-block;margin-left:10px;border-radius:30px;text-align:left;"
              v-for="(item, idx) in props.value"
              :key="idx"
              class="label blue">
                {{ item }}
              </div>
      </template>
      <template slot="col-item-affiliate_recruiter" slot-scope="props">
        <div
          style="display:inline-block;margin-left: 10px;border-radius:30px"
          v-if="props.value"
          class="label blue"
        >
          {{ props.value }}
        </div>
      </template>
      <template slot="col-item-print_permissions" slot-scope="props">
        <div
          style="display:inline-block;margin-left: 10px;border-radius:30px"
          class="label"
          :class="{
              'green' : props.value == true,
              'red' : props.value == false
          }"
        >
            {{props.value ? 'Enabled' : 'Disabled'}}
        </div>
      </template>
      <template slot="col-item-school_entered" slot-scope="props">
        <div
          style="display:inline-block;margin-left: 10px;border-radius:30px"
          class="label"
          :class="{
              'green' : props.value == true,
              'red' : props.value == false
          }"
        >
            {{props.value ? 'Yes' : 'No'}}
        </div>
      </template>
    </Grid>

    <q-layout-footer v-if="$p(['ADMIN','MANAGER','RECRUITER','AFFILIATE'],'or')">
        <q-toolbar>
          <q-toolbar-title>
          </q-toolbar-title>
          <q-btn
            label="New User"
            icon="add"
            color="primary"
            @click="openUserWizardModal()">
          </q-btn>
        </q-toolbar>
    </q-layout-footer> 
  </q-page>
</template>

<style lang="stylus">
</style>